import memoryCache from './memoryCache';
import localCache from './localCache';

// 缓存管理主模块，整合内存缓存和本地存储缓存
const cacheManager = {
  // 导出内存缓存实例
  memory: memoryCache,

  // 导出本地存储缓存实例
  local: localCache,

  // 三级缓存获取方法
  get: function (key) {
    // 1. 优先从内存缓存获取
    if (memoryCache.has(key)) {
      return memoryCache.get(key);
    }

    // 2. 从本地存储缓存获取
    const localValue = localCache.get(key);
    if (localValue !== null) {
      // 同步到内存缓存
      memoryCache.set(key, localValue);
      return localValue;
    }

    // 3. 缓存未命中
    return null;
  },

  // 三级缓存设置方法
  set: function (key, value, ttl = null) {
    // 1. 设置内存缓存
    memoryCache.set(key, value);

    // 2. 设置本地存储缓存
    return localCache.set(key, value, ttl);
  },

  // 批量设置缓存
  setMultiple: function (data, ttl = null) {
    // 1. 设置内存缓存
    memoryCache.setMultiple(data);

    // 2. 设置本地存储缓存
    if (typeof data === 'object') {
      Object.keys(data).forEach((key) => {
        localCache.set(key, data[key], ttl);
      });
    }
  },

  // 检查缓存是否存在
  has: function (key) {
    return memoryCache.has(key) || localCache.get(key) !== null;
  },

  // 清除所有缓存
  clearAll: function () {
    memoryCache.clear();
    localCache.clearAll();
  }
};

export default cacheManager;

export { memoryCache, localCache };


// WEBPACK FOOTER //
// ./src/utils/cache/cacheManager.js